import classNames from 'classnames';
import "./Logo.css";
import { jsx as _jsx } from "react/jsx-runtime";
export function Logo(_ref) {
  var className = _ref.className,
    style = _ref.style;
  return /*#__PURE__*/_jsx("div", {
    className: classNames('dh-logo', className),
    style: style
  });
}
export default Logo;
//# sourceMappingURL=Logo.js.map